
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as payKoXFLDlR_45vMA2wtekXwjwNqFqGn4QLqsaaMUFivKWGIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/pay.vue?macro=true";
import { default as error21Svvm29kEIObdwwAhxib_45pB4UJY_45nAbnEmcFpUmVygMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/error.vue?macro=true";
import { default as indexw7izAo_45U06mL0ggxIWvtEcDWsG5A3DdNpV0J4ulfW0IMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/index.vue?macro=true";
import { default as sssuEE5kieQ98OR4V7dlqhynLz3MGhiiS6NtoXl0CfMrDIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/sss.vue?macro=true";
import { default as sssFE7hIP1zFFFAgqb6uqfXGGdkbelh_45uSA6CXxn2eeNq8Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/sss.vue?macro=true";
import { default as girisEvxlG2x0LqaFG7rgdHUK6rxkpFsPc7xYD_45mlwxaaUhsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/giris.vue?macro=true";
import { default as indexmGlqrEzLzf46txHTMeGgHckCP8JEyQs2H4Bm5WSlTAYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/index.vue?macro=true";
import { default as rezervasyonVHS8q5_45FscJiybllIS8E5kt5K3b4rMpj_XQS_BH_MfwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/rezervasyon.vue?macro=true";
import { default as homemEWUHISRHduzSlJTpL5_45Vs47oledlwsh9q4WsHnUGSgMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home.vue?macro=true";
import { default as _91id_93mJvilI17fSjkkpG_enMPgKNiMy95CRbqkA2eAGqEtpsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/[id].vue?macro=true";
import { default as loginmNlmD3SDfsJcBt4xd_QHeMDu_45P_Kwc3VlRHiEWjBKJ4Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/login.vue?macro=true";
import { default as callsTUEpjJoQRUGkkamStleNBNP1SOmsoKlN7iq2H4AR80gMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/calls.vue?macro=true";
import { default as meta_45reviewRJyBJkknZKCOMYrSaFs30XMclgu8NjbMWcEcMG4PH0EMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/meta-review.vue?macro=true";
import { default as _91link_932N2SbPx327alN9v60sOe0g_45sc0bVkD1yRVQwlW_D7Y0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/[link].vue?macro=true";
import { default as _91link_938MzLKmFaOWGno0J8Wy9beEav6ZcgBYq_AkDThh3N4LUMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link].vue?macro=true";
import { default as signUp1XtXIaVOCq1CK0RB652ncxTg2mpx3kuFuhWv7cXK8owMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/signUp.vue?macro=true";
import { default as phonesEFZCMNVp_45Cl_45YyS_45ftYkybqu6kQrBZdUD8S553pH3r0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/phones.vue?macro=true";
import { default as hotels5f8czuRWTJfJ_6BkIzU4bqCiQKnT66yUkhDX2cYPctoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/hotels.vue?macro=true";
import { default as fail3QYiMyXKWXJD0ezjCj4d9nfTweZQsybEquFJxK0LbhwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/fail.vue?macro=true";
import { default as _91link_93OKmvp_dKq_45FNCOoXgJxx2K3vPO_54zl0CgQ8ofhb9xEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/[link].vue?macro=true";
import { default as callback41ay3dNtyzefJ7j9w2gvQCsMrbwz0XTDOksRFzO8CSkMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment/callback.vue?macro=true";
import { default as payment4Eeim6nqHqT5cil5a4WJZUh2knPqRl4ODdp42ITzoxgMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.vue?macro=true";
import { default as indextshSAmJChxRmcKrZS6NExclyGNaYiVIZcA1nQr0ZVNsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/contact/index.vue?macro=true";
import { default as _91id_93_46clientZl1jYV5kGGVEpnj0E6ac3S4XC1FqFY_35fQOjoRSPBMMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/[id].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as settingse9SslCaxBhoXVlvK4C5MABKS6ta0YtZJv9mP4vBSYroMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/settings.vue?macro=true";
import { default as dashboardK_RMuvh0Dn1RcBeQTeCVXF7rIZc92POFDs2pzBU86jQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/dashboard.vue?macro=true";
import { default as indexsFgX_xsq_MPC4AO26RZfNKl6x8Z_LnD1dvhBdCCymQoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/index.vue?macro=true";
import { default as payment_1_ghZyz_n9Xznk5o2l1HxHp4NYIi_6DE5FHqOVXmEwmwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment_1.vue?macro=true";
import { default as dashboardqPwkjaGBdqhfZwMDnNaw4JMkTNV7Y37UzJu3sdiRiDIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/dashboard.vue?macro=true";
import { default as newr7Tadikz3jEiNxZBYHW7uqZjqGZmHvaQyjwvZzBzHuoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/new.vue?macro=true";
import { default as _91id_93s27iW2fhei_45eybJif8rewLismdxzm_YqPmDjya4BeesMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/[id].vue?macro=true";
import { default as _91id_93pPIP8Y9IqWiS9s8BDNEJdgEqTImMVb1YWa8aZ8Wi8IIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/user/[id].vue?macro=true";
import { default as dashboard_m52_45hwtLkX3g2n6GBZ9QHwq_456sIbCBzsRn7YYfWd04Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/dashboard.vue?macro=true";
import { default as _91link_93chuXXQrgZRfZ36U_lqJ15sBgpHSGpGTHpcy0aaUfPlQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/[link].vue?macro=true";
import { default as hac_46clientc4T_UyXwDPxcL8D_45O7pvuKp1jSBWJUZau_FwJ74VQhAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hac.client.vue?macro=true";
import { default as successA_45UigaNSaj91KOZH6Z4zDtYH6O_45PbAlmn9mx_3Vc_soMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/success.vue?macro=true";
import { default as newgW6Ep0eAL6uTHVfmUHo114cAW4iikBIigPsknFKbhRwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/new.vue?macro=true";
import { default as _91link_93_45oldfQPytfnFsNOp_PWtrbMc4jB0ZNr9cVW38pQuX7AV1TcMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link]-old.vue?macro=true";
import { default as _91id_93QVsBloRitqeKV4G10E7XermpCnTD8eeuOupl2Pqe5GUMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/[id].vue?macro=true";
import { default as doc_45uploadES_bffo_45ZRodHKiXNHcf_QJV19bdg4BiYdAFxSEo4QUMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/doc-upload.vue?macro=true";
import { default as _91link_93ax8o5RVp_454csGgdDXW3k6j2NUb_45WMKYLzho9vMqIruMMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/[link].vue?macro=true";
import { default as _91id_93DosxNgxlmXDNsl1DMOHp9hivYTP2_45Ro51sY8nUbn5YMMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/[id].vue?macro=true";
import { default as _91id_93cnKTGlAkk7_Vr5kTyY8OCURHecCndcr3HvFL3L8t4ewMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/[id].vue?macro=true";
import { default as _91id_93IyTDjVo_KFgPSWcKab69BBeKmB9R2PoOVZH4gmg_45AbgMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/[id].vue?macro=true";
import { default as new_vS6FbA2iA4NIUw8pO_452dfs504NxqnmIrFBWKVSHk_45a0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/new_.vue?macro=true";
import { default as _91id_930BZ_45wW1NEA1fqSR4PmCytGAcikavB6rLxY1jmN6qmJoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/[id].vue?macro=true";
import { default as _91slug_932ODJetkUmuwG2O4ChLsRTDMheXsvY_NbigijjJMrEtQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/rehberler/[slug].vue?macro=true";
import { default as _91id_93CkE_45YdcVFe9ciKvGN_9sAEGrYe31DGYI7IObNkbmcQsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/detail/[id].vue?macro=true";
import { default as setPasswordcp9gL7p1xf3qavGxR20J9n1da1SdfcNPuI_C0TMKc5sMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/setPassword.vue?macro=true";
import { default as show_45ticketQqbSba_45OVnmlujteBIpup5MoqhrlFiIy8ANZmN5BwacMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/show-ticket.vue?macro=true";
import { default as indexB_489AEplOC3hBDqY9g2b_45ao_45a5gB28xtIp1cAl7VhsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/count/index.vue?macro=true";
import { default as indexC3XPVG4ho_LjRB9F6C1dsEYhLw6nPZ5EYU_Lflgl2ZwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/index.vue?macro=true";
import { default as indexZbJkljjHzbEtFhzEJg6_45zH5jTeZQ3KPsJnkHwO1S_45EwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/index.vue?macro=true";
import { default as indexQhdht7UYhAV0tCZC9jHIsBq853PXF750ws0QLS48_45_UMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/index.vue?macro=true";
import { default as indexyGqDOZGv_tlysBRVhMlu8NMtrxWIfRmpGhP7xvUBDoEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/index.vue?macro=true";
import { default as index8ZHP3buqIvAJX4GJ1LaMPKkgg4xT45hWZttrvBvnHpIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/index.vue?macro=true";
import { default as _91hash_93_46clientfHww0N8ch_46ekL_45IUvA5JXbLcu2tLYVq0J92MnlOlYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/o/[hash].client.vue?macro=true";
import { default as routes9lcH78E1uK7jqftnpBiQLP5HbelOZOPgqctzpJXuGhIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/routes.vue?macro=true";
import { default as userscHQyTNHToddeP828jlLwr62QaA2eUnGETYaw_45HEkmxsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/manage/users.vue?macro=true";
import { default as _91id_93VsTNM9NUJzBv2W97BmPdq7uRsHgVRBKmcXCPxFXvqXQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/[id].vue?macro=true";
import { default as _91link_93MGzcsouFgjqGLXx6fDkYyeNXDWu4jx5BnhCpq5_nj_45YMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/iframe/tour/[link].vue?macro=true";
import { default as ongoing_45toursCKrv2dA_45tbFuuwT5s2xl7YKFF7sQoMTUbJSuQPZ8qkEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/ongoing-tours.vue?macro=true";
import { default as flight_45searchGgZlubFNDDKMaroPF_45JOfaCrhekuEIignmgI4y47jN0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/flight-search.vue?macro=true";
import { default as indexhin_45b8ZjJSu_451cA_uXeDAr0TJ9oQCOCUQCfzD3g69QcMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/index.vue?macro=true";
import { default as allToursd_ZXVVkuTXnnujLwJ7NdUptMYPLwONAXfwsazOl_4581MMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/allTours.vue?macro=true";
import { default as forgotPasswordmqg101qZXZ3N2anVed01yYYM9Ng8TOoimkg9js24AJAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/forgotPassword.vue?macro=true";
import { default as quiz_45_91id_93mSX7VGgto2ZpBzuDRxyHpaooj_JnOiATp5FHcGfTjEoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/quiz/quiz-[id].vue?macro=true";
import { default as index_46clientY_456lRcOytLLGvkTskWIKH_czPOLbHEta4VY46aUEq08Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/yardim/index.client.vue?macro=true";
import { default as indexvyd9_45VERdnnUduNHM4sJ1_4505GtGMoHIdaPt9b_HXur4Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/comments/index.vue?macro=true";
import { default as _91id_93QHxLLu_bWu3Uig0qJydBll2J2qIGFsQrnMLxXQnCuLIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/[id].vue?macro=true";
import { default as persona_45statusOfi3_45vi5PsH_45npnEiZomAACBIVobeR0A9SPeQzlrRfYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/persona-status.vue?macro=true";
import { default as agentsD8geIT9xsVLuPUCqxkmJyf_45P9YxKNwM9f2x__8jC8XwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/agents.vue?macro=true";
import { default as logsjlpGvCYlR3AWV9Im0zOpIAzaBxifgWnGUPQJaNuHBk4Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/order/[orderId]/logs.vue?macro=true";
import { default as confirm_45account4f0tmhkpKbhQ5pvN_HLTJTFo7NLUuaV2jid3j0qwNS0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/confirm-account.vue?macro=true";
import { default as qr_45login_46clientqeDlIBN8ZEPgUfX80MgSWO9TpovNwEugjVz4g7tCpkgMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/qr-login.client.vue?macro=true";
import { default as indexBMm5gfCzYnfaCaoHCK9nWhiFBNvGvm6t7i_j6qwPoPEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/index.vue?macro=true";
import { default as indexDzqw7WW34OlDxSgGFaunxj39w5ureGyw91BmIRBTF3QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/passports/index.vue?macro=true";
import { default as indexRzDpUraoo8dWMpMWybw_Qlz0ajY7_Rmteze27_wCujEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/pax-files/index.vue?macro=true";
import { default as bus_45_91date_934hzsq1_45pkFQfEBrDh_jRLRkffHQkUrCdvf9Dm5V5q8QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/bus-[date].vue?macro=true";
import { default as ops_45_91date_93N1bbLNsdjJvIHrpNxoksvqIBmKQIaIi90gd2iqC3ET8Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/ops-[date].vue?macro=true";
import { default as edit8T85k_1Vw0JGzYqoR4STbYygdGfrb1wKQ41Ln_45Gv_45KUMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/edit.vue?macro=true";
import { default as index3rBN9fgqHhbXezA9bZ0o24xnmFV3bzWjcjFcgv8w20oMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/index.vue?macro=true";
import { default as clientscnpL3H_45WI_45EXOdIBRkVpWovuJbs_NvLdX1Zsundge4UMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/microapi/clients.vue?macro=true";
import { default as guidespsVjZ7ekHUNv04v2tECMweu8t2lWK_FMrTNOzAklJWAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guides.vue?macro=true";
import { default as verimor_45settingsrhmzZ8EY9NeIeGPRnX6RWVjsP_PiAMoAo24Ii0x4gpoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/verimor-settings.vue?macro=true";
import { default as _91id_93_46clientdMYJcM95VxlSjaOVsd6LH9MmhGPwHwyOU_7iLasFQ9QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/entry/[id].client.vue?macro=true";
import { default as virman5cf4xna0wHCZP0IkLfgRPCA6YbV03PZtCnnkUlkv1VAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/virman.vue?macro=true";
import { default as _91id_93mxO8SifaL5NEvKCI_b9jHLJXke_j_45JipRwOFIJnt2isMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/[id].vue?macro=true";
import { default as whatsappth4e49U9qdVMUHgb__45IPcIOF2cmdsDAl8ZO7yaH8vmMMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/messages/whatsapp.vue?macro=true";
import { default as tour_45risktiU_45zuwTiBSswOYRF5pApCwMNbyMonAH9VMYnk9xpPIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/tour-risk.vue?macro=true";
import { default as _91id_93Msu7J1FOwmo_45ClvxH0Krj4vCGkbngN7LgaqzI6X_45FK8Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/[id].vue?macro=true";
import { default as check_45_91date_933jS9ZXrPn_8KY6A37ioEHEhxavWqdv7MXr_45j_jb6ASsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/check-[date].vue?macro=true";
import { default as print_45_91date_93eGQLhWLgxqTsQPo5UgkiRcd4lPtn2a3dmIYw1evO56cMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/print-[date].vue?macro=true";
import { default as _91id_938IDzEYPlOk5lTzVqBeNC4w_sf9iWJmODnPP4rRJ3c5AMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/[id].vue?macro=true";
import { default as _91id_93U1TqIuJirNOqODE_45GR88G23HBhVa51B2JjlBHLZheqcMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/[id].vue?macro=true";
import { default as pasaport_45dogrulama3zWy6GycVGEJZLoU86gUukIZGJkU_45OjiTFVivZN9d8AMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/pasaport-dogrulama.vue?macro=true";
import { default as _91link_93OrgUEd_g485cBqvXNp_WBd_45jYHdzMYSFXpLt_VX7hSwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/print/[link].vue?macro=true";
import { default as indexPwBvIUsuhiAxk4ofwBYB5ic1hF9adFHb9B5drbJK5pEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/index.vue?macro=true";
import { default as requestsJpvvf49cPuCg8M3MD1OenRgnww3Olje3elSU2ffX6aEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/requests.vue?macro=true";
import { default as _91id_93_45VUw5XCP0sdDJzh1Eerm_45WjudwvSOmy_45FPz2bcFz1K4Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/[id].vue?macro=true";
import { default as google_45adsdjHXTOxJzSutg6ZBTZ8Gf6Ndt6Aoc8_45SCYx2WjLV1awMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/google-ads.vue?macro=true";
import { default as indexn7_45mGU5IG_TgcPfvUwDbsKo7CCXH9lzfrhHm78Yq7HYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/index.vue?macro=true";
import { default as index89G2Lgo75NeqcM0XP_4tT1jcBuGNHoY70LZGUbn2l9QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/index.vue?macro=true";
import { default as indexbXVe6h_8OyTU5Oq0OvYVXMQkCATr_45WRsqbHrIW_JKDsMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/index.vue?macro=true";
import { default as service_45_91id_93ft2GfkHz_45xons1NrQZ1vHq_45i1Er7opX9MiTzg8EMu9QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/service-[id].vue?macro=true";
import { default as private_45umrah_45toursQKokOimFyJxsGt9KpeRrVvwhhUYBO6vnRZ14WCRORlIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/private-umrah-tours.vue?macro=true";
import { default as birthdaystX7ajMEe23Xu40dLmII8dXwadHpFVZgBvYMVwAw2_NkMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/birthdays.vue?macro=true";
import { default as index_45A9fFFwA8mszwCYzbKAp_45EHuQAFwYBPmH5I6nz2EmUwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hajj-registry/index.vue?macro=true";
import { default as indexJMIfaqkNHisZyhtKwH3NXCtnpFikXp5CgvTPdHhMU0wMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/index.vue?macro=true";
import { default as airport_45_91date_93BQ8Pmkg6E390MAOKxVhy11wNsoM4Mjg6MdNl_cad3pYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/airport-[date].vue?macro=true";
import { default as cocukla_45umre_45rehberiCEJ5wYPvGkUgdgksFOPRScF96J51YUt14glz4SB4MToMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/cocukla-umre-rehberi.vue?macro=true";
import { default as hday_4520_91year_93_45_91name_93eIKe8KfnTy66drhDJdiXFQAz2Ogpvm7_TXIq8W5WSKkMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hday-20[year]-[name].vue?macro=true";
import { default as cash_45period_45approvalneF4G1h_6b25bShIb_457I84TQlW_yNBQRGd4Z1et_XhEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/cash-period-approval.vue?macro=true";
import { default as hakkimizda_46clientjgdWuuHqWOiAXhw1_45KQjaGAN6c5JOTaIKU3_cF6VNQIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/hakkimizda.client.vue?macro=true";
import { default as kadin_45irsad_45gorevlisi9yF9f2BSpgzLoEW2DgZC_U5urLX5baWlDCOVB14IFloMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/kadin-irsad-gorevlisi.vue?macro=true";
import { default as nusuk_45ravza_45randevusucwt2ZEhXTGV_45Tn_45M0RqHVujw0ccRsMyBryVX6pGMzLYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/nusuk-ravza-randevusu.vue?macro=true";
import { default as umre_45otelleri_45rehberi4k81R31r_45BePTUjrnazQ_45CoW1ALAA3UCncyyQ_wZdgoMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-otelleri-rehberi.vue?macro=true";
import { default as log_45_91id_93pGYS0jKBxyq1GcaCKOp7yo_45cHI8uVn6txRv4iCBm52QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/log-[id].vue?macro=true";
import { default as changePasswordRKNekyEMTyRWcbSZVc7ItMfmHgfiLvWiCmgCEJz7T3YMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/account/changePassword.vue?macro=true";
import { default as _91type_93_45_91id_93md7PlSbDumkqKgtrT0KGr0i7dsjBgVtmb6waxnHrLDkMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/pdf/[type]-[id].vue?macro=true";
import { default as umre_45hizmet_45standartlarisaFEX_455HnrkhVNzgkrW49oOlatysUL9vFKAyLvwA1WgMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-hizmet-standartlari.vue?macro=true";
import { default as kisiye_45ozel_45umre_45turlarii10pJF0jxjIInuYdavyqura3OR8Hp3OBHoD_456jT4reAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/kisiye-ozel-umre-turlari.vue?macro=true";
import { default as _91slug_93tHXvGhnWuNZYXLx34utR5WK9fDrEcuUdKeux33j9cUcMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/ornek-programlar/[slug].vue?macro=true";
import { default as guide_45planning5GOjXLlLV9ZvsD0HSzgzKFQ10SURvWBSs0RWrfOfrt0Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guide-planning.vue?macro=true";
import { default as competitor_45toursM1FESnO1zXcab27a146rpD2ahAAwLHw6d7P_45R0FB1iEMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/competitor-tours.vue?macro=true";
import { default as ilk_45kez_45umreye_45gideceklerH2gNavo3VpgitJvCv2Fv_45TwEaV7KjclaPtxjLeYGXaQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/ilk-kez-umreye-gidecekler.vue?macro=true";
import { default as reservation_45successz6PL_45KCZb6NQXMgf7l0vxcLGW2F7i_45slbtBO4HytsRYMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/reservation-success.vue?macro=true";
import { default as newTransactionpOjfsiT8wNsaS6_459p2fu3pUpMcBtgEx4SqemmXYzRI4Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/newTransaction.vue?macro=true";
import { default as umre_45icin_45gerekli_45belgelervCCqFIYOXJ4m4ZXFou_45hmZXSFv6Wu6KEwEYmebydA_45sMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-icin-gerekli-belgeler.vue?macro=true";
import { default as yaslilar_45icin_45umre_45rehberix3RkDZdjVAvvX_AHFoyo3FpSXMfXKh_2pezv_VLpS8QMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/yaslilar-icin-umre-rehberi.vue?macro=true";
import { default as payment_46before_45hosting_46bakfZOdLxPf_45fYErM3nkNcR42twR1mviICgObXW7GEffP8Meta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.before-hosting.bak.vue?macro=true";
import { default as whatsapp_450850vlDiy69hpyY3gnKW_3Qh9rg2yZzT2gMVadHxizGOkkIMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/integrations/whatsapp-0850.vue?macro=true";
import { default as reservation_45seasonnt_455TJb9h3d0_45JOnP43BCEeVEK635GVXM4FLUT8mz0sMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/reservation-season.vue?macro=true";
import { default as roommate_45matchingxhTjl8Jw4L6qGdGV0JWIc5veoqlQgm4iqj2Ua_45RfaPQMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/roommate-matching.vue?macro=true";
import { default as passport_45date_45validity_45checklNn9Ulwn5ZEMHX_45KHOfZqWFU8TCwLqoLBXT7aayT1XAMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/passport-date-validity-check.vue?macro=true";
import { default as en_45iyi_45umre_45turu_45nasil_45secilirowK_45D2EpvpSdB84xIj1XWXOlde3HFuc07_ey7phCCUwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/en-iyi-umre-turu-nasil-secilir.vue?macro=true";
import { default as definite_45reservationxNVJ30q5OYpD06ZhdAKb_45q7vchp1rU53XuzN3e4qxgwMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/definite-reservation.vue?macro=true";
import { default as component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta } from "/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g } from "/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "pay___tr",
    path: "/pay",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/pay.vue")
  },
  {
    name: "pay___en",
    path: "/en/pay",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/pay.vue")
  },
  {
    name: "error___tr",
    path: "/error",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/error.vue")
  },
  {
    name: "index___tr",
    path: "/",
    meta: indexw7izAo_45U06mL0ggxIWvtEcDWsG5A3DdNpV0J4ulfW0IMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexw7izAo_45U06mL0ggxIWvtEcDWsG5A3DdNpV0J4ulfW0IMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/index.vue")
  },
  {
    name: "user-sss___tr",
    path: "/user/sss",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/sss.vue")
  },
  {
    name: "user-sss___en",
    path: "/en/user/sss",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/sss.vue")
  },
  {
    name: homemEWUHISRHduzSlJTpL5_45Vs47oledlwsh9q4WsHnUGSgMeta?.name,
    path: "/user/home",
    meta: homemEWUHISRHduzSlJTpL5_45Vs47oledlwsh9q4WsHnUGSgMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home.vue"),
    children: [
  {
    name: "user-home-sss___tr",
    path: "sss",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/sss.vue")
  },
  {
    name: "user-home-giris___tr",
    path: "giris",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/giris.vue")
  },
  {
    name: "user-home___tr",
    path: "",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/index.vue")
  },
  {
    name: "user-home-rezervasyon___tr",
    path: "rezervasyon",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/rezervasyon.vue")
  }
]
  },
  {
    name: homemEWUHISRHduzSlJTpL5_45Vs47oledlwsh9q4WsHnUGSgMeta?.name,
    path: "/en/user/home",
    meta: homemEWUHISRHduzSlJTpL5_45Vs47oledlwsh9q4WsHnUGSgMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home.vue"),
    children: [
  {
    name: "user-home-sss___en",
    path: "sss",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/sss.vue")
  },
  {
    name: "user-home-giris___en",
    path: "giris",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/giris.vue")
  },
  {
    name: "user-home___en",
    path: "",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/index.vue")
  },
  {
    name: "user-home-rezervasyon___en",
    path: "rezervasyon",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/home/rezervasyon.vue")
  }
]
  },
  {
    name: "hotel-id___tr",
    path: "/hotel/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/[id].vue")
  },
  {
    name: "hotel-id___en",
    path: "/en/hotel/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/[id].vue")
  },
  {
    name: "user-login___tr",
    path: "/user/login",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/login.vue")
  },
  {
    name: "user-login___en",
    path: "/en/user/login",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/login.vue")
  },
  {
    name: "admin-calls___tr",
    path: "/admin/calls",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/calls.vue")
  },
  {
    name: "admin-calls___en",
    path: "/en/admin/calls",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/calls.vue")
  },
  {
    name: "meta-review___tr",
    path: "/meta-review",
    meta: meta_45reviewRJyBJkknZKCOMYrSaFs30XMclgu8NjbMWcEcMG4PH0EMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/meta-review.vue")
  },
  {
    name: "meta-review___en",
    path: "/en/meta-review",
    meta: meta_45reviewRJyBJkknZKCOMYrSaFs30XMclgu8NjbMWcEcMG4PH0EMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/meta-review.vue")
  },
  {
    name: "page-link___tr",
    path: "/page/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/[link].vue")
  },
  {
    name: "page-link___en",
    path: "/en/page/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/[link].vue")
  },
  {
    name: "tour-link___tr",
    path: "/tour/:link()",
    meta: _91link_938MzLKmFaOWGno0J8Wy9beEav6ZcgBYq_AkDThh3N4LUMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link].vue")
  },
  {
    name: "tour-link___en",
    path: "/en/tour/:link()",
    meta: _91link_938MzLKmFaOWGno0J8Wy9beEav6ZcgBYq_AkDThh3N4LUMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link].vue")
  },
  {
    name: "user-signUp___tr",
    path: "/user/signUp",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/signUp.vue")
  },
  {
    name: "user-signUp___en",
    path: "/en/user/signUp",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/signUp.vue")
  },
  {
    name: "admin-phones___tr",
    path: "/admin/phones",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/phones.vue")
  },
  {
    name: "admin-phones___en",
    path: "/en/admin/phones",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/phones.vue")
  },
  {
    name: "hotel-hotels___tr",
    path: "/hotel/hotels",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/hotels.vue")
  },
  {
    name: "hotel-hotels___en",
    path: "/en/hotel/hotels",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/hotel/hotels.vue")
  },
  {
    name: "payment-fail___tr",
    path: "/payment/fail",
    meta: fail3QYiMyXKWXJD0ezjCj4d9nfTweZQsybEquFJxK0LbhwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/fail.vue")
  },
  {
    name: "payment-fail___en",
    path: "/en/payment/fail",
    meta: fail3QYiMyXKWXJD0ezjCj4d9nfTweZQsybEquFJxK0LbhwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/fail.vue")
  },
  {
    name: "tours-link___tr",
    path: "/tours/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/[link].vue")
  },
  {
    name: "tours-link___en",
    path: "/en/tours/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/[link].vue")
  },
  {
    name: "user-payment___tr",
    path: "/user/payment",
    meta: payment4Eeim6nqHqT5cil5a4WJZUh2knPqRl4ODdp42ITzoxgMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.vue"),
    children: [
  {
    name: "user-payment-callback___tr",
    path: "callback",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment/callback.vue")
  }
]
  },
  {
    name: "user-payment___en",
    path: "/en/user/payment",
    meta: payment4Eeim6nqHqT5cil5a4WJZUh2knPqRl4ODdp42ITzoxgMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.vue"),
    children: [
  {
    name: "user-payment-callback___en",
    path: "callback",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment/callback.vue")
  }
]
  },
  {
    name: "contact___tr",
    path: "/contact",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/contact/index.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/contact/index.vue")
  },
  {
    name: "r-id___tr",
    path: "/r/:id()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/[id].client.vue"))
  },
  {
    name: "r-id___en",
    path: "/en/r/:id()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/[id].client.vue"))
  },
  {
    name: "user-settings___tr",
    path: "/user/settings",
    meta: settingse9SslCaxBhoXVlvK4C5MABKS6ta0YtZJv9mP4vBSYroMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/settings.vue")
  },
  {
    name: "user-settings___en",
    path: "/en/user/settings",
    meta: settingse9SslCaxBhoXVlvK4C5MABKS6ta0YtZJv9mP4vBSYroMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/settings.vue")
  },
  {
    name: "user-dashboard___tr",
    path: "/user/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/dashboard.vue")
  },
  {
    name: "user-dashboard___en",
    path: "/en/user/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/dashboard.vue")
  },
  {
    name: "user-lms___tr",
    path: "/user/lms",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/index.vue")
  },
  {
    name: "user-lms___en",
    path: "/en/user/lms",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/index.vue")
  },
  {
    name: "user-payment_1___tr",
    path: "/user/payment_1",
    meta: payment_1_ghZyz_n9Xznk5o2l1HxHp4NYIi_6DE5FHqOVXmEwmwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment_1.vue")
  },
  {
    name: "user-payment_1___en",
    path: "/en/user/payment_1",
    meta: payment_1_ghZyz_n9Xznk5o2l1HxHp4NYIi_6DE5FHqOVXmEwmwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment_1.vue")
  },
  {
    name: "admin-dashboard___tr",
    path: "/admin/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/dashboard.vue")
  },
  {
    name: "admin-dashboard___en",
    path: "/en/admin/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/dashboard.vue")
  },
  {
    name: "admin-tasks-new___tr",
    path: "/admin/tasks/new",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/new.vue")
  },
  {
    name: "admin-tasks-new___en",
    path: "/en/admin/tasks/new",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/new.vue")
  },
  {
    name: "admin-tour-id___tr",
    path: "/admin/tour/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/[id].vue")
  },
  {
    name: "admin-tour-id___en",
    path: "/en/admin/tour/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/[id].vue")
  },
  {
    name: "admin-user-id___tr",
    path: "/admin/user/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/user/[id].vue")
  },
  {
    name: "admin-user-id___en",
    path: "/en/admin/user/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/user/[id].vue")
  },
  {
    name: "agent-dashboard___tr",
    path: "/agent/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/dashboard.vue")
  },
  {
    name: "agent-dashboard___en",
    path: "/en/agent/dashboard",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/dashboard.vue")
  },
  {
    name: "kurumsal-link___tr",
    path: "/kurumsal/:link()",
    meta: _91link_93chuXXQrgZRfZ36U_lqJ15sBgpHSGpGTHpcy0aaUfPlQMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/[link].vue")
  },
  {
    name: "kurumsal-link___en",
    path: "/en/kurumsal/:link()",
    meta: _91link_93chuXXQrgZRfZ36U_lqJ15sBgpHSGpGTHpcy0aaUfPlQMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/[link].vue")
  },
  {
    name: "page-hac___tr",
    path: "/page/hac",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hac.client.vue"))
  },
  {
    name: "page-hac___en",
    path: "/en/page/hac",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hac.client.vue"))
  },
  {
    name: "payment-success___tr",
    path: "/payment/success",
    meta: successA_45UigaNSaj91KOZH6Z4zDtYH6O_45PbAlmn9mx_3Vc_soMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/success.vue")
  },
  {
    name: "payment-success___en",
    path: "/en/payment/success",
    meta: successA_45UigaNSaj91KOZH6Z4zDtYH6O_45PbAlmn9mx_3Vc_soMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/payment/success.vue")
  },
  {
    name: "reservation-new___tr",
    path: "/reservation/new",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/new.vue")
  },
  {
    name: "reservation-new___en",
    path: "/en/reservation/new",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/new.vue")
  },
  {
    name: "tour-link-old___tr",
    path: "/tour/:link()-old",
    meta: _91link_93_45oldfQPytfnFsNOp_PWtrbMc4jB0ZNr9cVW38pQuX7AV1TcMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link]-old.vue")
  },
  {
    name: "tour-link-old___en",
    path: "/en/tour/:link()-old",
    meta: _91link_93_45oldfQPytfnFsNOp_PWtrbMc4jB0ZNr9cVW38pQuX7AV1TcMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/[link]-old.vue")
  },
  {
    name: "tourDetail-id___tr",
    path: "/tourDetail/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/[id].vue")
  },
  {
    name: "tourDetail-id___en",
    path: "/en/tourDetail/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/[id].vue")
  },
  {
    name: "user-doc-upload___tr",
    path: "/user/doc-upload",
    meta: doc_45uploadES_bffo_45ZRodHKiXNHcf_QJV19bdg4BiYdAFxSEo4QUMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/doc-upload.vue")
  },
  {
    name: "user-doc-upload___en",
    path: "/en/user/doc-upload",
    meta: doc_45uploadES_bffo_45ZRodHKiXNHcf_QJV19bdg4BiYdAFxSEo4QUMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/doc-upload.vue")
  },
  {
    name: "user-lms-link___tr",
    path: "/user/lms/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/[link].vue")
  },
  {
    name: "user-lms-link___en",
    path: "/en/user/lms/:link()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/lms/[link].vue")
  },
  {
    name: "admin-hotel-id___tr",
    path: "/admin/hotel/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/[id].vue")
  },
  {
    name: "admin-hotel-id___en",
    path: "/en/admin/hotel/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/[id].vue")
  },
  {
    name: "admin-notes-id___tr",
    path: "/admin/notes/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/[id].vue")
  },
  {
    name: "admin-notes-id___en",
    path: "/en/admin/notes/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/[id].vue")
  },
  {
    name: "admin-offer-id___tr",
    path: "/admin/offer/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/[id].vue")
  },
  {
    name: "admin-offer-id___en",
    path: "/en/admin/offer/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/[id].vue")
  },
  {
    name: "admin-offer-new____tr",
    path: "/admin/offer/new_",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/new_.vue")
  },
  {
    name: "admin-offer-new____en",
    path: "/en/admin/offer/new_",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/new_.vue")
  },
  {
    name: "agent-offer-id___tr",
    path: "/agent/offer/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/[id].vue")
  },
  {
    name: "agent-offer-id___en",
    path: "/en/agent/offer/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/[id].vue")
  },
  {
    name: "rehberler-slug___tr",
    path: "/rehberler/:slug()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/rehberler/[slug].vue")
  },
  {
    name: "rehberler-slug___en",
    path: "/en/rehberler/:slug()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/rehberler/[slug].vue")
  },
  {
    name: "tour-detail-id___tr",
    path: "/tour/detail/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/detail/[id].vue")
  },
  {
    name: "tour-detail-id___en",
    path: "/en/tour/detail/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/detail/[id].vue")
  },
  {
    name: "user-setPassword___tr",
    path: "/user/setPassword",
    meta: setPasswordcp9gL7p1xf3qavGxR20J9n1da1SdfcNPuI_C0TMKc5sMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/setPassword.vue")
  },
  {
    name: "user-setPassword___en",
    path: "/en/user/setPassword",
    meta: setPasswordcp9gL7p1xf3qavGxR20J9n1da1SdfcNPuI_C0TMKc5sMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/setPassword.vue")
  },
  {
    name: "user-show-ticket___tr",
    path: "/user/show-ticket",
    meta: show_45ticketQqbSba_45OVnmlujteBIpup5MoqhrlFiIy8ANZmN5BwacMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/show-ticket.vue")
  },
  {
    name: "user-show-ticket___en",
    path: "/en/user/show-ticket",
    meta: show_45ticketQqbSba_45OVnmlujteBIpup5MoqhrlFiIy8ANZmN5BwacMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/show-ticket.vue")
  },
  {
    name: "admin-count___tr",
    path: "/admin/count",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/count/index.vue")
  },
  {
    name: "admin-count___en",
    path: "/en/admin/count",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/count/index.vue")
  },
  {
    name: "admin-hotel___tr",
    path: "/admin/hotel",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/index.vue")
  },
  {
    name: "admin-hotel___en",
    path: "/en/admin/hotel",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hotel/index.vue")
  },
  {
    name: "admin-notes___tr",
    path: "/admin/notes",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/index.vue")
  },
  {
    name: "admin-notes___en",
    path: "/en/admin/notes",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/notes/index.vue")
  },
  {
    name: "admin-offer___tr",
    path: "/admin/offer",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/index.vue")
  },
  {
    name: "admin-offer___en",
    path: "/en/admin/offer",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/offer/index.vue")
  },
  {
    name: "admin-tasks___tr",
    path: "/admin/tasks",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/index.vue")
  },
  {
    name: "admin-tasks___en",
    path: "/en/admin/tasks",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tasks/index.vue")
  },
  {
    name: "agent-offer___tr",
    path: "/agent/offer",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/index.vue")
  },
  {
    name: "agent-offer___en",
    path: "/en/agent/offer",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/offer/index.vue")
  },
  {
    name: "r-o-hash___tr",
    path: "/r/o/:hash()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/o/[hash].client.vue"))
  },
  {
    name: "r-o-hash___en",
    path: "/en/r/o/:hash()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/r/o/[hash].client.vue"))
  },
  {
    name: "tourDetail-routes___tr",
    path: "/tourDetail/routes",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/routes.vue")
  },
  {
    name: "tourDetail-routes___en",
    path: "/en/tourDetail/routes",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/routes.vue")
  },
  {
    name: "admin-manage-users___tr",
    path: "/admin/manage/users",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/manage/users.vue")
  },
  {
    name: "admin-manage-users___en",
    path: "/en/admin/manage/users",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/manage/users.vue")
  },
  {
    name: "admin-reports-id___tr",
    path: "/admin/reports/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/[id].vue")
  },
  {
    name: "admin-reports-id___en",
    path: "/en/admin/reports/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/[id].vue")
  },
  {
    name: "iframe-tour-link___tr",
    path: "/iframe/tour/:link()",
    meta: _91link_93MGzcsouFgjqGLXx6fDkYyeNXDWu4jx5BnhCpq5_nj_45YMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/iframe/tour/[link].vue")
  },
  {
    name: "iframe-tour-link___en",
    path: "/en/iframe/tour/:link()",
    meta: _91link_93MGzcsouFgjqGLXx6fDkYyeNXDWu4jx5BnhCpq5_nj_45YMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/iframe/tour/[link].vue")
  },
  {
    name: "tour-ongoing-tours___tr",
    path: "/tour/ongoing-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/ongoing-tours.vue")
  },
  {
    name: "tour-ongoing-tours___en",
    path: "/en/tour/ongoing-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/ongoing-tours.vue")
  },
  {
    name: "admin-flight-search___tr",
    path: "/admin/flight-search",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/flight-search.vue")
  },
  {
    name: "admin-flight-search___en",
    path: "/en/admin/flight-search",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/flight-search.vue")
  },
  {
    name: "admin-reports___tr",
    path: "/admin/reports",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports___en",
    path: "/en/admin/reports",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/index.vue")
  },
  {
    name: "admin-tour-allTours___tr",
    path: "/admin/tour/allTours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/allTours.vue")
  },
  {
    name: "admin-tour-allTours___en",
    path: "/en/admin/tour/allTours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/allTours.vue")
  },
  {
    name: "user-forgotPassword___tr",
    path: "/user/forgotPassword",
    meta: forgotPasswordmqg101qZXZ3N2anVed01yYYM9Ng8TOoimkg9js24AJAMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/forgotPassword.vue")
  },
  {
    name: "user-forgotPassword___en",
    path: "/en/user/forgotPassword",
    meta: forgotPasswordmqg101qZXZ3N2anVed01yYYM9Ng8TOoimkg9js24AJAMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/forgotPassword.vue")
  },
  {
    name: "user-quiz-quiz-id___tr",
    path: "/user/quiz/quiz-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/quiz/quiz-[id].vue")
  },
  {
    name: "user-quiz-quiz-id___en",
    path: "/en/user/quiz/quiz-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/quiz/quiz-[id].vue")
  },
  {
    name: "yardim___tr",
    path: "/yardim",
    meta: index_46clientY_456lRcOytLLGvkTskWIKH_czPOLbHEta4VY46aUEq08Meta || {},
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/yardim/index.client.vue"))
  },
  {
    name: "yardim___en",
    path: "/en/yardim",
    meta: index_46clientY_456lRcOytLLGvkTskWIKH_czPOLbHEta4VY46aUEq08Meta || {},
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/yardim/index.client.vue"))
  },
  {
    name: "admin-comments___tr",
    path: "/admin/comments",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/comments/index.vue")
  },
  {
    name: "admin-comments___en",
    path: "/en/admin/comments",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/comments/index.vue")
  },
  {
    name: "admin-customers-id___tr",
    path: "/admin/customers/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/[id].vue")
  },
  {
    name: "admin-customers-id___en",
    path: "/en/admin/customers/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/[id].vue")
  },
  {
    name: "admin-persona-status___tr",
    path: "/admin/persona-status",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/persona-status.vue")
  },
  {
    name: "admin-persona-status___en",
    path: "/en/admin/persona-status",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/persona-status.vue")
  },
  {
    name: "admin-reports-agents___tr",
    path: "/admin/reports/agents",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/agents.vue")
  },
  {
    name: "admin-reports-agents___en",
    path: "/en/admin/reports/agents",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/agents.vue")
  },
  {
    name: "order-orderId-logs___tr",
    path: "/order/:orderId()/logs",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/order/[orderId]/logs.vue")
  },
  {
    name: "order-orderId-logs___en",
    path: "/en/order/:orderId()/logs",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/order/[orderId]/logs.vue")
  },
  {
    name: "user-confirm-account___tr",
    path: "/user/confirm-account",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/confirm-account.vue")
  },
  {
    name: "user-confirm-account___en",
    path: "/en/user/confirm-account",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/confirm-account.vue")
  },
  {
    name: "user-qr-login___tr",
    path: "/user/qr-login",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/qr-login.client.vue"))
  },
  {
    name: "user-qr-login___en",
    path: "/en/user/qr-login",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/qr-login.client.vue"))
  },
  {
    name: "admin-customers___tr",
    path: "/admin/customers",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/index.vue")
  },
  {
    name: "admin-customers___en",
    path: "/en/admin/customers",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/index.vue")
  },
  {
    name: "admin-passports___tr",
    path: "/admin/passports",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/passports/index.vue")
  },
  {
    name: "admin-passports___en",
    path: "/en/admin/passports",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/passports/index.vue")
  },
  {
    name: "admin-pax-files___tr",
    path: "/admin/pax-files",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/pax-files/index.vue")
  },
  {
    name: "admin-pax-files___en",
    path: "/en/admin/pax-files",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/pax-files/index.vue")
  },
  {
    name: "admin-tour-bus-date___tr",
    path: "/admin/tour/bus-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/bus-[date].vue")
  },
  {
    name: "admin-tour-bus-date___en",
    path: "/en/admin/tour/bus-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/bus-[date].vue")
  },
  {
    name: "admin-tour-ops-date___tr",
    path: "/admin/tour/ops-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/ops-[date].vue")
  },
  {
    name: "admin-tour-ops-date___en",
    path: "/en/admin/tour/ops-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/ops-[date].vue")
  },
  {
    name: "reservation-id-edit___tr",
    path: "/reservation/:id()/edit",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/edit.vue")
  },
  {
    name: "reservation-id-edit___en",
    path: "/en/reservation/:id()/edit",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/edit.vue")
  },
  {
    name: "admin-accounting___tr",
    path: "/admin/accounting",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/index.vue")
  },
  {
    name: "admin-accounting___en",
    path: "/en/admin/accounting",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/index.vue")
  },
  {
    name: "admin-microapi-clients___tr",
    path: "/admin/microapi/clients",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/microapi/clients.vue")
  },
  {
    name: "admin-microapi-clients___en",
    path: "/en/admin/microapi/clients",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/microapi/clients.vue")
  },
  {
    name: "admin-operation-guides___tr",
    path: "/admin/operation/guides",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guides.vue")
  },
  {
    name: "admin-operation-guides___en",
    path: "/en/admin/operation/guides",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guides.vue")
  },
  {
    name: "admin-verimor-settings___tr",
    path: "/admin/verimor-settings",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/verimor-settings.vue")
  },
  {
    name: "admin-verimor-settings___en",
    path: "/en/admin/verimor-settings",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/verimor-settings.vue")
  },
  {
    name: "user-entry-id___tr",
    path: "/user/entry/:id()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/entry/[id].client.vue"))
  },
  {
    name: "user-entry-id___en",
    path: "/en/user/entry/:id()",
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/entry/[id].client.vue"))
  },
  {
    name: "admin-accounting-virman___tr",
    path: "/admin/accounting/virman",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/virman.vue")
  },
  {
    name: "admin-accounting-virman___en",
    path: "/en/admin/accounting/virman",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/virman.vue")
  },
  {
    name: "admin-availability-id___tr",
    path: "/admin/availability/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/[id].vue")
  },
  {
    name: "admin-availability-id___en",
    path: "/en/admin/availability/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/[id].vue")
  },
  {
    name: "admin-messages-whatsapp___tr",
    path: "/admin/messages/whatsapp",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/messages/whatsapp.vue")
  },
  {
    name: "admin-messages-whatsapp___en",
    path: "/en/admin/messages/whatsapp",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/messages/whatsapp.vue")
  },
  {
    name: "admin-reports-tour-risk___tr",
    path: "/admin/reports/tour-risk",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/tour-risk.vue")
  },
  {
    name: "admin-reports-tour-risk___en",
    path: "/en/admin/reports/tour-risk",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/tour-risk.vue")
  },
  {
    name: "admin-reservations-id___tr",
    path: "/admin/reservations/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/[id].vue")
  },
  {
    name: "admin-reservations-id___en",
    path: "/en/admin/reservations/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/[id].vue")
  },
  {
    name: "admin-tour-check-date___tr",
    path: "/admin/tour/check-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/check-[date].vue")
  },
  {
    name: "admin-tour-check-date___en",
    path: "/en/admin/tour/check-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/check-[date].vue")
  },
  {
    name: "admin-tour-print-date___tr",
    path: "/admin/tour/print-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/print-[date].vue")
  },
  {
    name: "admin-tour-print-date___en",
    path: "/en/admin/tour/print-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/print-[date].vue")
  },
  {
    name: "admin-userDataForm-id___tr",
    path: "/admin/userDataForm/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/[id].vue")
  },
  {
    name: "admin-userDataForm-id___en",
    path: "/en/admin/userDataForm/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/[id].vue")
  },
  {
    name: "agent-reservations-id___tr",
    path: "/agent/reservations/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/[id].vue")
  },
  {
    name: "agent-reservations-id___en",
    path: "/en/agent/reservations/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/[id].vue")
  },
  {
    name: "page-pasaport-dogrulama___tr",
    path: "/page/pasaport-dogrulama",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/pasaport-dogrulama.vue")
  },
  {
    name: "page-pasaport-dogrulama___en",
    path: "/en/page/pasaport-dogrulama",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/pasaport-dogrulama.vue")
  },
  {
    name: "tourDetail-print-link___tr",
    path: "/tourDetail/print/:link()",
    meta: _91link_93OrgUEd_g485cBqvXNp_WBd_45jYHdzMYSFXpLt_VX7hSwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/print/[link].vue")
  },
  {
    name: "tourDetail-print-link___en",
    path: "/en/tourDetail/print/:link()",
    meta: _91link_93OrgUEd_g485cBqvXNp_WBd_45jYHdzMYSFXpLt_VX7hSwMeta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/print/[link].vue")
  },
  {
    name: "admin-availability___tr",
    path: "/admin/availability",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/index.vue")
  },
  {
    name: "admin-availability___en",
    path: "/en/admin/availability",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/availability/index.vue")
  },
  {
    name: "admin-operation-requests___tr",
    path: "/admin/operation/requests",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/requests.vue")
  },
  {
    name: "admin-operation-requests___en",
    path: "/en/admin/operation/requests",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/requests.vue")
  },
  {
    name: "admin-private-tours-id___tr",
    path: "/admin/private-tours/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/[id].vue")
  },
  {
    name: "admin-private-tours-id___en",
    path: "/en/admin/private-tours/:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/[id].vue")
  },
  {
    name: "admin-reports-google-ads___tr",
    path: "/admin/reports/google-ads",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/google-ads.vue")
  },
  {
    name: "admin-reports-google-ads___en",
    path: "/en/admin/reports/google-ads",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/google-ads.vue")
  },
  {
    name: "admin-reservations___tr",
    path: "/admin/reservations",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/index.vue")
  },
  {
    name: "admin-reservations___en",
    path: "/en/admin/reservations",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/index.vue")
  },
  {
    name: "admin-userDataForm___tr",
    path: "/admin/userDataForm",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/index.vue")
  },
  {
    name: "admin-userDataForm___en",
    path: "/en/admin/userDataForm",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/userDataForm/index.vue")
  },
  {
    name: "agent-reservations___tr",
    path: "/agent/reservations",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/index.vue")
  },
  {
    name: "agent-reservations___en",
    path: "/en/agent/reservations",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/agent/reservations/index.vue")
  },
  {
    name: "reservation-service-id___tr",
    path: "/reservation/service-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/service-[id].vue")
  },
  {
    name: "reservation-service-id___en",
    path: "/en/reservation/service-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/service-[id].vue")
  },
  {
    name: "tour-private-umrah-tours___tr",
    path: "/tour/private-umrah-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/private-umrah-tours.vue")
  },
  {
    name: "tour-private-umrah-tours___en",
    path: "/en/tour/private-umrah-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/private-umrah-tours.vue")
  },
  {
    name: "admin-customers-birthdays___tr",
    path: "/admin/customers/birthdays",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/birthdays.vue")
  },
  {
    name: "admin-customers-birthdays___en",
    path: "/en/admin/customers/birthdays",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/customers/birthdays.vue")
  },
  {
    name: "admin-hajj-registry___tr",
    path: "/admin/hajj-registry",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hajj-registry/index.vue")
  },
  {
    name: "admin-hajj-registry___en",
    path: "/en/admin/hajj-registry",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/hajj-registry/index.vue")
  },
  {
    name: "admin-private-tours___tr",
    path: "/admin/private-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/index.vue")
  },
  {
    name: "admin-private-tours___en",
    path: "/en/admin/private-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/private-tours/index.vue")
  },
  {
    name: "admin-tour-airport-date___tr",
    path: "/admin/tour/airport-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/airport-[date].vue")
  },
  {
    name: "admin-tour-airport-date___en",
    path: "/en/admin/tour/airport-:date()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/tour/airport-[date].vue")
  },
  {
    name: "page-cocukla-umre-rehberi___tr",
    path: "/page/cocukla-umre-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/cocukla-umre-rehberi.vue")
  },
  {
    name: "page-cocukla-umre-rehberi___en",
    path: "/en/page/cocukla-umre-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/cocukla-umre-rehberi.vue")
  },
  {
    name: "page-hday-20year-name___tr",
    path: "/page/hday-20:year()-:name()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hday-20[year]-[name].vue")
  },
  {
    name: "page-hday-20year-name___en",
    path: "/en/page/hday-20:year()-:name()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/hday-20[year]-[name].vue")
  },
  {
    name: "admin-cash-period-approval___tr",
    path: "/admin/cash-period-approval",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/cash-period-approval.vue")
  },
  {
    name: "admin-cash-period-approval___en",
    path: "/en/admin/cash-period-approval",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/cash-period-approval.vue")
  },
  {
    name: "kurumsal-hakkimizda___tr",
    path: "/kurumsal/hakkimizda",
    meta: hakkimizda_46clientjgdWuuHqWOiAXhw1_45KQjaGAN6c5JOTaIKU3_cF6VNQIMeta || {},
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/hakkimizda.client.vue"))
  },
  {
    name: "kurumsal-hakkimizda___en",
    path: "/en/kurumsal/hakkimizda",
    meta: hakkimizda_46clientjgdWuuHqWOiAXhw1_45KQjaGAN6c5JOTaIKU3_cF6VNQIMeta || {},
    component: () => createClientPage(() => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/kurumsal/hakkimizda.client.vue"))
  },
  {
    name: "page-kadin-irsad-gorevlisi___tr",
    path: "/page/kadin-irsad-gorevlisi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/kadin-irsad-gorevlisi.vue")
  },
  {
    name: "page-kadin-irsad-gorevlisi___en",
    path: "/en/page/kadin-irsad-gorevlisi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/kadin-irsad-gorevlisi.vue")
  },
  {
    name: "page-nusuk-ravza-randevusu___tr",
    path: "/page/nusuk-ravza-randevusu",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/nusuk-ravza-randevusu.vue")
  },
  {
    name: "page-nusuk-ravza-randevusu___en",
    path: "/en/page/nusuk-ravza-randevusu",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/nusuk-ravza-randevusu.vue")
  },
  {
    name: "page-umre-otelleri-rehberi___tr",
    path: "/page/umre-otelleri-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-otelleri-rehberi.vue")
  },
  {
    name: "page-umre-otelleri-rehberi___en",
    path: "/en/page/umre-otelleri-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-otelleri-rehberi.vue")
  },
  {
    name: "admin-reservations-log-id___tr",
    path: "/admin/reservations/log-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/log-[id].vue")
  },
  {
    name: "admin-reservations-log-id___en",
    path: "/en/admin/reservations/log-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reservations/log-[id].vue")
  },
  {
    name: "user-account-changePassword___tr",
    path: "/user/account/changePassword",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/account/changePassword.vue")
  },
  {
    name: "user-account-changePassword___en",
    path: "/en/user/account/changePassword",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/account/changePassword.vue")
  },
  {
    name: "admin-reports-pdf-type-id___tr",
    path: "/admin/reports/pdf/:type()-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/pdf/[type]-[id].vue")
  },
  {
    name: "admin-reports-pdf-type-id___en",
    path: "/en/admin/reports/pdf/:type()-:id()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/pdf/[type]-[id].vue")
  },
  {
    name: "page-umre-hizmet-standartlari___tr",
    path: "/page/umre-hizmet-standartlari",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-hizmet-standartlari.vue")
  },
  {
    name: "page-umre-hizmet-standartlari___en",
    path: "/en/page/umrah-service-standards",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-hizmet-standartlari.vue")
  },
  {
    name: "tour-kisiye-ozel-umre-turlari___tr",
    path: "/tour/kisiye-ozel-umre-turlari",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/kisiye-ozel-umre-turlari.vue")
  },
  {
    name: "tour-kisiye-ozel-umre-turlari___en",
    path: "/en/tour/kisiye-ozel-umre-turlari",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tour/kisiye-ozel-umre-turlari.vue")
  },
  {
    name: "tours-ornek-programlar-slug___tr",
    path: "/tours/ornek-programlar/:slug()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/ornek-programlar/[slug].vue")
  },
  {
    name: "tours-ornek-programlar-slug___en",
    path: "/en/tours/ornek-programlar/:slug()",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tours/ornek-programlar/[slug].vue")
  },
  {
    name: "admin-operation-guide-planning___tr",
    path: "/admin/operation/guide-planning",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guide-planning.vue")
  },
  {
    name: "admin-operation-guide-planning___en",
    path: "/en/admin/operation/guide-planning",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/guide-planning.vue")
  },
  {
    name: "admin-reports-competitor-tours___tr",
    path: "/admin/reports/competitor-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/competitor-tours.vue")
  },
  {
    name: "admin-reports-competitor-tours___en",
    path: "/en/admin/reports/competitor-tours",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/competitor-tours.vue")
  },
  {
    name: "page-ilk-kez-umreye-gidecekler___tr",
    path: "/page/ilk-kez-umreye-gidecekler",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/ilk-kez-umreye-gidecekler.vue")
  },
  {
    name: "page-ilk-kez-umreye-gidecekler___en",
    path: "/en/page/ilk-kez-umreye-gidecekler",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/ilk-kez-umreye-gidecekler.vue")
  },
  {
    name: "tourDetail-reservation-success___tr",
    path: "/tourDetail/reservation-success",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/reservation-success.vue")
  },
  {
    name: "tourDetail-reservation-success___en",
    path: "/en/tourDetail/reservation-success",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/tourDetail/reservation-success.vue")
  },
  {
    name: "admin-accounting-newTransaction___tr",
    path: "/admin/accounting/newTransaction",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/newTransaction.vue")
  },
  {
    name: "admin-accounting-newTransaction___en",
    path: "/en/admin/accounting/newTransaction",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/accounting/newTransaction.vue")
  },
  {
    name: "page-umre-icin-gerekli-belgeler___tr",
    path: "/page/umre-icin-gerekli-belgeler",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-icin-gerekli-belgeler.vue")
  },
  {
    name: "page-umre-icin-gerekli-belgeler___en",
    path: "/en/page/umre-icin-gerekli-belgeler",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/umre-icin-gerekli-belgeler.vue")
  },
  {
    name: "page-yaslilar-icin-umre-rehberi___tr",
    path: "/page/yaslilar-icin-umre-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/yaslilar-icin-umre-rehberi.vue")
  },
  {
    name: "page-yaslilar-icin-umre-rehberi___en",
    path: "/en/page/yaslilar-icin-umre-rehberi",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/yaslilar-icin-umre-rehberi.vue")
  },
  {
    name: "user-payment.before-hosting.bak___tr",
    path: "/user/payment.before-hosting.bak",
    meta: payment_46before_45hosting_46bakfZOdLxPf_45fYErM3nkNcR42twR1mviICgObXW7GEffP8Meta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.before-hosting.bak.vue")
  },
  {
    name: "user-payment.before-hosting.bak___en",
    path: "/en/user/payment.before-hosting.bak",
    meta: payment_46before_45hosting_46bakfZOdLxPf_45fYErM3nkNcR42twR1mviICgObXW7GEffP8Meta || {},
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/user/payment.before-hosting.bak.vue")
  },
  {
    name: "admin-integrations-whatsapp-0850___tr",
    path: "/admin/integrations/whatsapp-0850",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/integrations/whatsapp-0850.vue")
  },
  {
    name: "admin-integrations-whatsapp-0850___en",
    path: "/en/admin/integrations/whatsapp-0850",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/integrations/whatsapp-0850.vue")
  },
  {
    name: "admin-reports-reservation-season___tr",
    path: "/admin/reports/reservation-season",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/reservation-season.vue")
  },
  {
    name: "admin-reports-reservation-season___en",
    path: "/en/admin/reports/reservation-season",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/reports/reservation-season.vue")
  },
  {
    name: "admin-operation-roommate-matching___tr",
    path: "/admin/operation/roommate-matching",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/roommate-matching.vue")
  },
  {
    name: "admin-operation-roommate-matching___en",
    path: "/en/admin/operation/roommate-matching",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/admin/operation/roommate-matching.vue")
  },
  {
    name: "page-passport-date-validity-check___tr",
    path: "/page/passport-date-validity-check",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/passport-date-validity-check.vue")
  },
  {
    name: "page-passport-date-validity-check___en",
    path: "/en/page/passport-date-validity-check",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/passport-date-validity-check.vue")
  },
  {
    name: "page-en-iyi-umre-turu-nasil-secilir___tr",
    path: "/page/en-iyi-umre-turu-nasil-secilir",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/en-iyi-umre-turu-nasil-secilir.vue")
  },
  {
    name: "page-en-iyi-umre-turu-nasil-secilir___en",
    path: "/en/page/en-iyi-umre-turu-nasil-secilir",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/page/en-iyi-umre-turu-nasil-secilir.vue")
  },
  {
    name: "reservation-id-definite-reservation___tr",
    path: "/reservation/:id()/definite-reservation",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/definite-reservation.vue")
  },
  {
    name: "reservation-id-definite-reservation___en",
    path: "/en/reservation/:id()/definite-reservation",
    component: () => import("/Users/demir/projects/inanctur/inanctur.com.tr/pages/reservation/[id]/definite-reservation.vue")
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/konya-umre-turlari-sube",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/konya-umre-turlari-sube",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/tr/hakkimizda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/tr/hakkimizda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/istanbul_hotels",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/istanbul_hotels",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/blog/hac-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/blog/hac-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en5-star-luxury-umrah-packages",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en5-star-luxury-umrah-packages",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/enpage/yorumlar",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/enpage/yorumlar",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/tour/kandil-gecesi-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/tour/kandil-gecesi-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/vipumre/vip-umre-programlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/vipumre/vip-umre-programlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tour/l/kudus-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tour/l/kudus-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/sayfa/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/sayfa/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre_ve_farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/kisiye-ozel-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/kisiye-ozel-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/trade",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/trade",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre-nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre-nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre_nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre_nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre_nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre_nedir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/ihram",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/ihram",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/home",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/home",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/home",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/home",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/user/login/signUp",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/user/login/signUp",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/hakkimizda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/hakkimizda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/hakkimizda?changeCurrency=TL&urge=ok",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/hakkimizda?changeCurrency=TL&urge=ok",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/hakkimizda?changeCurrency=Euro&urge=ok",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/hakkimizda?changeCurrency=Euro&urge=ok",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre_turlari_hakkinda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre_turlari_hakkinda",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/hotel/yalova_termal_otel",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/hotel/yalova_termal_otel",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre_sayfa_yan_",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre_sayfa_yan_",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre-rehberi",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre-rehberi",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/e_odeme",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/e_odeme",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/contact/vcard.html",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/contact/vcard.html",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/sayfa/umre_nerede_yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/sayfa/umre_nerede_yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/yorumlar",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/yorumlar",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/temmuz-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/temmuz-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/7-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/7-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/7-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/7-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/7-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/7-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/5-yildizli-luks-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/5-yildizli-luks-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/5-yildizli-luks-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/5-yildizli-luks-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/12-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/12-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/12-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/12-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tour/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tour/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/tour/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/tour/14-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/14-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/14-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tour/14-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/tour/14-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/15-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/15-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/15-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/15-gunluk-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/15-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/15-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/february-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/february-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/september-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/september-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/january-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/january-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/mart-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/mart-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/mart-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/mart-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/april-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/april-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/june-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/june-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/10-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/10-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/12-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/12-days-umrah-tours",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/5-star-luxury-umrah-packages",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/5-star-luxury-umrah-packages",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/user/quiz/quiz-all",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/user/quiz/quiz-all",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/about-us",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/about-us",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre-fiyatlari-nasil-hesaplanir_",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-fiyatlari-nasil-hesaplanir_",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre_fiyatlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre_fiyatlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/umre/umre-turlari.html",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/umre/umre-turlari.html",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/agustos-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/agustos-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/temmuz-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/temmuz-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/ekim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/eylul-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/aralik-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/haziran-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/haziran-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/kasim-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/mayis-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/mayis-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/nisan-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/nisan-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/ocak-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/somestr-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/somestr-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/subat-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/ramazan-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/ramazan-umre-turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-ve-farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umre-ve-farzlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/detail",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/detail",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-turlari-nezaman-yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umre-turlari-nezaman-yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-fiyatlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umre-fiyatlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-kalite-politikamiz",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umre-kalite-politikamiz",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/balayi_umre_turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/balayi_umre_turlari",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umre-nasil-yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umre-nasil-yapilir",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/avrupadan-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/avrupadan-umre",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/umrah-from-europe",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page/umrah-from-europe",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/page/kosova’da_iklim_ve_hava_durumu",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page/kosova’da_iklim_ve_hava_durumu",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/tr/:pathMatch(.*)",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/tr/:pathMatch(.*)",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/page",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  },
  {
    name: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45gMeta?.name,
    path: "/en/en/page",
    component: component_45stubDkIWZxNC9wQjPg9UpahNdL5kVFK4VncSPAkXrQkqI_45g
  }
]